import { useState, useCallback } from 'react';
import { useOidcContext } from '../contexts/OidcContext';
import { api } from '../api';
import { PortalMcpLogOut as McpLog } from '../types/apiRequests';

export function useServerLogs(serverName: string | undefined, isBeheerder: boolean) {
  const { getAccessTokenSilently } = useOidcContext();
  const [serverLogs, setServerLogs] = useState<McpLog[]>([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [logsLoaded, setLogsLoaded] = useState(false);

  const loadServerLogs = useCallback(async () => {
    if (!serverName || !isBeheerder) return;
    setLogsLoading(true);
    try {
      const token = await getAccessTokenSilently();
      setServerLogs(await api.getServerLogs(token, serverName));
    } finally {
      setLogsLoading(false);
      setLogsLoaded(true);
    }
  }, [serverName, isBeheerder, getAccessTokenSilently]);

  return { serverLogs, logsLoading, logsLoaded, loadServerLogs };
}
